import React, { useRef } from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import MyComponent from './MyComponent';
import Recaptcha from './Recaptcha';
import { getApiBaseUrl } from '../../../src/common/constants';
import LoadingSpinnerComponent from './LoadingSpinner';

interface optInFormData {

  phoneNumber: string[];
  subName: string;
  email: string;
  affil: string;
  provGrpNm: string;
  isAcknowledged: boolean;
}

export const Optin_recaptcha = () => {

  const[loader,setLoader]=React.useState(false);
const [recaptchaToken, setRecaptchaToken] = React.useState<string | null>(null);
  const recaptchaRef = useRef<{ execute: () => Promise<string> } | null>(null);

  const [areaCodes, setAreaCodes] = React.useState<any[]>();

  React.useEffect(() => {
  const apiUrl = getApiBaseUrl();
  if (!apiUrl) return;
  fetch(apiUrl + '/area-codes')
  .then((res) => res.json())
  .then((data) => {
    const areaCodesArray = Array.isArray(data.results) ? data.results : [];
    setAreaCodes(areaCodesArray);
  })
  .catch((err) => {
    setAreaCodes([]);
  });
  }, []);

  const [optInData, setOptInData] = React.useState<optInFormData>({
    phoneNumber: [],
    subName: '',
    email: '',
    affil: '',
    provGrpNm: '',
    isAcknowledged: false,
  });

  const [currentPhoneNumber, setCurrentPhoneNumber] = React.useState('');
  const [areaCodeError, setAreaCodeError] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [isAddPhoneModalOpen, setIsAddPhoneModalOpen] = React.useState(false);
  const [modalPhoneNumber, setModalPhoneNumber] = React.useState('');
  const [modalError, setModalError] = React.useState('');
  const [tempPhoneNumbers, setTempPhoneNumbers] = React.useState<string[]>([]);
  const [duplicateWarning, setDuplicateWarning] = React.useState('');
  const [duplicatemsg, setDuplicateMsg] = React.useState('');
  const [successModalOpen, setSuccessModalOpen] = React.useState(false);

  const [captchaNum1, setCaptchaNum1] = React.useState(0);
  const [captchaNum2, setCaptchaNum2] = React.useState(0);
  const [captchaAnswer, setCaptchaAnswer] = React.useState('');
  const [captchaValid, setCaptchaValid] = React.useState(false);
  const [captchaError, setCaptchaError] = React.useState('');

  const generateCaptcha = React.useCallback(() => {
    const num1 = Math.floor(Math.random() * 900) + 100;
    const num2 = Math.floor(Math.random() * 90) + 10;
    setCaptchaNum1(num1);
    setCaptchaNum2(num2);
    setCaptchaAnswer('');
    setCaptchaValid(false);
    setCaptchaError('');
  }, []);

  React.useEffect(() => {
    generateCaptcha();
  }, [generateCaptcha]);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value;
    setOptInData({ ...optInData, email: email });

    if (email.trim() !== '' && !validateEmail(email)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const handleOpenModal = () => {
    setModalPhoneNumber('');
    setModalError('');

    if (optInData.phoneNumber.length > 0) {
      setTempPhoneNumbers([...optInData.phoneNumber]);
    } else {
      setTempPhoneNumbers([]);
    }

    setIsAddPhoneModalOpen(true);
  };

  const handleAddPhoneToTempList = () => {
  if (modalPhoneNumber.trim() !== '') {
    const digitsOnly = modalPhoneNumber.replace(/\D/g, '');

    if (digitsOnly.length !== 10) {
      setModalError('Invalid phone number. Please enter a valid 10-digit phone number.');
      return;
    }

    if (tempPhoneNumbers.includes(modalPhoneNumber)) {
      setDuplicateMsg('Phone number already entered on the form.');
      return;
    }

    if (optInData.phoneNumber.includes(modalPhoneNumber)) {
      setDuplicateMsg('Phone number already entered on the form.');
      return;
    }

    if (currentPhoneNumber && modalPhoneNumber === currentPhoneNumber) {
      setDuplicateMsg('Phone number already entered on the form.');
      return;
    }

    setTempPhoneNumbers([modalPhoneNumber, ...tempPhoneNumbers]);
    setModalPhoneNumber('');
    setModalError('');
  } else {
    setModalError('Please enter a phone number before adding.');
  }
};
  const handleRemoveFromTempList = (index: number) => {
    const updatedTempList = tempPhoneNumbers.filter((_, i) => i !== index);
    setTempPhoneNumbers(updatedTempList);
  };

  const handleSaveAllPhoneNumbers = () => {
    setOptInData({
      ...optInData,
      phoneNumber: [...tempPhoneNumbers]
    });

    if (currentPhoneNumber && tempPhoneNumbers.includes(currentPhoneNumber)) {
      setCurrentPhoneNumber('');
    }

    setTempPhoneNumbers([]);
    setModalPhoneNumber('');
    setModalError('');
    setIsAddPhoneModalOpen(false);
  };

  const handleCloseModal = () => {
    setModalPhoneNumber('');
    setModalError('');
    setTempPhoneNumbers([]);
    setIsAddPhoneModalOpen(false);
  };

  const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCaptchaAnswer(value);

    if (value.trim() === '') {
      setCaptchaValid(false);
      setCaptchaError('');
      return;
    }

    // Only allow numeric input
    if (!/^[0-9]+$/.test(value)) {
      setCaptchaValid(false);
      setCaptchaError('Please enter a valid number');
      return;
    }

    const userAnswer = parseInt(value, 10);
    const correctAnswer = captchaNum1 + captchaNum2;
    if (userAnswer === correctAnswer) {
      setCaptchaValid(true);
      setCaptchaError('Verification successful!');
    } else {
      setCaptchaValid(false);
      setCaptchaError('Wrong answer');
    }
  };

  return (
    <div style={{ margin: '40px', maxHeight: '800px', overflowY: 'auto' }}>

      <Grid style={{ marginTop: '20px',marginLeft:'1px',width:'99%' }} >
        <Grid.Col span={8}>

          <Grid>
            <Grid.Col span={12}>
              <h3>
                Telephone Consumer Protection Act (TCPA) opt-in form for healthcare
                providers
              </h3>
              <div
                style={{
                  marginTop: '20px',
                }}
              >
                Please complete the following form to opt in to reviewing automated or
                artificial outreach communications from UnitedHealthcare. Once
                completed, click Submit, at the bottom of the form. This opt-in will
                stay effect until we receive a notice to opt in.
              </div>
            </Grid.Col>
          </Grid>



          <Grid>
            <Grid.Col span={10}>
              <span style={{ fontWeight: 'bold' }}>
                Designate the number at which you would like to be contacted for automated or artificial voice calls<span style={{
                  color: 'red',fontSize:'20px'
                }}> *</span>
              </span>
            </Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={4}>
              <TextInput
                css={{
                  'abyss-text-input': {
                    marginTop: '-10px !important'
                  }
                }}
                label=""
                mask="phone"
                value={currentPhoneNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrentPhoneNumber(value);
                  const digits = value.replace(/\D/g, '');
                  if (digits.length >= 3) {
                    const area = digits.substring(0, 3);
                    if (areaCodes && areaCodes.length > 0 && !areaCodes.includes(area)) {
                      setAreaCodeError('Invalid area code. Please enter a valid area code.');
                    } else {
                      setAreaCodeError('');
                    }
                  } else {
                    setAreaCodeError('');
                  }
                }}
                autoComplete="tel-local"
                inputLeftElement={
                  <IconSymbol icon="phone" color="#002677" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '-10px'
                    }
                  }} />
                }
              />
              {areaCodeError && (
                <div style={{ color: 'red', fontSize: '13px', marginTop: '2px' }}>{areaCodeError}</div>
              )}
            </Grid.Col>
            <Grid.Col span={4} ></Grid.Col>

          </Grid>
           <Grid >
            <Grid.Col span={8}>
              {optInData.phoneNumber.length > 0 && (
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '10px',
                  marginTop: '10px'
                }}>
                  {optInData.phoneNumber.map((phoneNumber, index) => (
                    <Badge
                      key={index}
                      rounded
                      variant="info"
                      outline
                      css={{
                        'abyss-badge': {
                          padding: '6px 10px !important',
                          fontSize: '14px',
                          display: 'inline-flex !important',
                          alignItems: 'center !important',
                          gap: '6px',
                          lineHeight: '1 !important',
                          height: 'auto !important'
                        }
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        lineHeight: '1'
                      }}>
                        <IconSymbol icon="phone" size="16px" style={{ display: 'flex' }} />
                        <span style={{ display: 'flex', alignItems: 'center' }}>{phoneNumber}</span>
                        <IconSymbol
                          icon="close"
                          size="16px"
                          style={{ display: 'flex', cursor: 'pointer' }}
                          onClick={() => {
                            const updatedPhoneNumbers = optInData.phoneNumber.filter((_, i) => i !== index);
                            console.log('Removing phone number at index:', index);
                            console.log('Updated array:', updatedPhoneNumbers);
                            setOptInData({ ...optInData, phoneNumber: updatedPhoneNumbers });
                          }}
                        />
                      </div>
                    </Badge>
                  ))}
                </div>
              )}
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={4}>
                <Button
                variant="outline"
                after={<IconSymbol icon="add_circle" />}
                onClick={handleOpenModal}
                isDisabled={currentPhoneNumber.replace(/\D/g, '').length !== 10 || areaCodeError !== ''}
              >
                Add phone number
              </Button>
            </Grid.Col>
             <Grid.Col span={8}>
            </Grid.Col>
          </Grid>



          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={4}>
              <TextInput
                label="Submitter name"
                value={optInData.subName}
                onChange={(e) => setOptInData({ ...optInData, subName: e.target.value })}
                inputLeftElement={
                  <IconSymbol icon="person" color="#002677" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '0px'
                    }
                  }} />
                }
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <TextInput
                label="Email Address"
                value={optInData.email}
                onChange={handleEmailChange}
                inputLeftElement={
                  <IconSymbol icon="email" color="#002677" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '0px'
                    }
                  }} />
                }
              />
              {emailError && (
                <div style={{ color: 'red', fontSize: '13px', marginTop: '2px' }}>{emailError}</div>
              )}
            </Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8}>
              <RadioGroup display="row" label="Affiliation" value={optInData.affil} onChange={(e) => setOptInData({ ...optInData, affil: e.target.value })}>
                <RadioGroup.Radio label="Provider" value="Provider" />
                <RadioGroup.Radio label="Office staff" value="os" />
                <RadioGroup.Radio label="Scheduling/Billing" value="sb" />
                <RadioGroup.Radio label="Vendor" value="v" />
                <RadioGroup.Radio label="Other" value="o" />
              </RadioGroup>
            </Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8}>
              <TextInput
                label="Provider group name(s)"
                value={optInData.provGrpNm}
                onChange={(e) => setOptInData({ ...optInData, provGrpNm: e.target.value })}
                inputLeftElement={
                  <IconSymbol icon="group" color="#002677" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '0px'
                    }
                  }} />
                }
              />
            </Grid.Col>
          </Grid>

        <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8}>
              <div style={{
                padding: '20px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                border: '1px solid #e0e0e0',
                marginTop: '20px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  marginBottom: '10px'
                }}>
                  <IconSymbol icon="shield" color="#002677" size="24px" />
                  <span style={{ fontWeight: 'bold', fontSize: '16px' }}>
                    Verify you're human
                  </span>
                </div>
                <div style={{ maxWidth: '300px', margin: '0 auto' }}>
                  <Recaptcha
                    ref={recaptchaRef}
                    sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '6LeutxksAAAAAHUdDdAIXtv85GWU1OQRDrJMORfQ'}
                    onChange={(token: string | null) => {
                      setRecaptchaToken(token);
                    }}
                  />
                </div>
              </div>
            </Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8}>
              <Checkbox
                css={{
                  'abyss-checkbox-label': {
                    fontWeight: 'bold'
                  }
                }}
                label={(<>I acknowledge that by checking Submit, I agree to allow UnitedHeadthcare and its affilates to call the phone number(s) I have provided using an autodialer and/or artificial or prerecorded voice technology.<span style={{ color: 'red',fontSize:"20px" }}> *</span></>) as any}
                isChecked={optInData.isAcknowledged}
                onChange={e => setOptInData({ ...optInData, isAcknowledged: e.target.checked })}
              />
            </Grid.Col>
          </Grid>

        </Grid.Col>
      </Grid>



      <Button
        style={{ marginTop: '20px' }}
        isDisabled={
          (optInData.phoneNumber.length === 0 && currentPhoneNumber.replace(/\D/g, '').length !== 10) ||
          !optInData.isAcknowledged ||
          areaCodeError !== '' ||
          !recaptchaToken
        }
        onClick={async () => {
          setLoader(true);
          if (optInData.email && !validateEmail(optInData.email)) {
            setLoader(false);
      setErrorMessage('Please enter a valid email address before submitting.');
      return;
    }

    let allPhoneNumbers = [...optInData.phoneNumber];

    if (currentPhoneNumber && currentPhoneNumber.replace(/\D/g, '').length === 10) {
      if (!allPhoneNumbers.includes(currentPhoneNumber)) {
        allPhoneNumbers.push(currentPhoneNumber);
      }
    }

    const formattedPhoneNumbers = allPhoneNumbers.map(phone => phone.replace(/\D/g, ''));

    const phoneNumbersString = formattedPhoneNumbers.join(', ');

    const submitPayload = {
      ...optInData,
      phoneNumbers: phoneNumbersString
    };

           try {
                const apiUrl = getApiBaseUrl();
                if (!apiUrl) throw new Error('API base URL not available');
                const response = await fetch(apiUrl + '/upsert', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    applicationName: 'robo',
                    phoneNumber: phoneNumbersString,
                    action: 'upsert',
                    subName: optInData.subName,
                    consentType: 'I',
                    email: optInData.email,
                    provGrpNm: optInData.provGrpNm,
                    affil: optInData.affil
                  })
                });
                // if (!response.ok) {
                //   throw new Error('Network response was not ok');
                // }
                const data = await response.json();
                console.log('POST response status:', response);
                console.log('POST success:', data);
                if (data && data.status && data.status.code === 201 && data.status.text === "Record updated successfully") {
 setLoader(false);
 setOptInData({
   phoneNumber: [],
   subName: '',
   email: '',
   affil: '',
   provGrpNm: '',
   isAcknowledged: false,
 });
 setCurrentPhoneNumber('');
 setCaptchaAnswer('');
 setCaptchaValid(false);
 setCaptchaError('');
 generateCaptcha();
 setSuccessModalOpen(true);
                } else {
                  setLoader(false);
                  setErrorMessage((data && data.status && data.status.text) || 'Unknown error occurred');
                }
              } catch (error) {
                setLoader(false);
                console.error('POST error:', error);
                setErrorMessage('POST error: ' + (error?.message || error));
              }
        }}
      >
        Submit
      </Button>

      <Modal
        isOpen={errorMessage !== ''}
        closeOnClickOutside={false}
        title="Alert !!!"
        model="closeOnClickOutside-modal"
        onClose={() => {
          setErrorMessage('');
        }}
      >
        <Modal.Section>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{errorMessage}</div>
        </Modal.Section>
        <Modal.Section>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => setErrorMessage('')}>
              OK
            </Button>
          </div>
        </Modal.Section>
      </Modal>

      <Modal
        isOpen={duplicateWarning !== ''}
        closeOnClickOutside={false}
        title="Duplicate Phone Number"
        model="duplicate-warning-modal"
        onClose={() => {
          setDuplicateWarning('');
        }}
      >
        <Modal.Section>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{duplicateWarning}</div>
        </Modal.Section>
        <Modal.Section>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => setDuplicateWarning('')}>
              OK
            </Button>
          </div>
        </Modal.Section>
      </Modal>

      <Modal
        isOpen={duplicatemsg !== ''}
        size={'$sm'}
        closeOnClickOutside={false}
        title=""
        onClose={() => {
          setDuplicateMsg('');
        }}
      >
        <Modal.Section>
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginTop: '10px' }}>{duplicatemsg}</div>
        </Modal.Section>
      </Modal>

      <Modal
        isOpen={successModalOpen}
        closeOnClickOutside={false}
        title=""
        model="success-modal"
        onClose={() => {
          setSuccessModalOpen(false);
        }}
      >
        <Modal.Section>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <div style={{
              flexShrink: 0,
              backgroundColor: '#e8f5e9',
              borderRadius: '50%',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <IconSymbol icon="check_circle" color="#4caf50" size="48px" />
            </div>
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: 'bold',lineHeight: '1.2'  }}>
                Thank you for registering your telephone number(s).
              </h3>
              <p style={{ margin: 0, fontSize: '16px', lineHeight: '1.5' }}>
                Please allow 10 business days to be added to the Opt In registry. Once complete, you will be eligible to receive auto-dialer, artificial or pre-recorded calls.
              </p>
            </div>
          </div>
        </Modal.Section>

      </Modal>

      <Modal
        isOpen={isAddPhoneModalOpen}
        closeOnClickOutside={false}
        title="Add additional Phone numbers"
        model="add-phone-modal"
        onClose={handleCloseModal}
        css={{
          'abyss-modal-content': {
            minWidth: '500px'
          }
        }}
      >
        <Modal.Section>
          <div style={{ marginBottom: '20px' }}>
            <Grid>
              <Grid.Col span={8}>
                <span>List additional phone numbers to exclude from automated calls.</span>
                <TextInput
                  label="Phone numbers"
                  mask="phone"
                  value={modalPhoneNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalPhoneNumber(value);
                    setModalError('');
                    const digits = value.replace(/\D/g, '');
                    if (digits.length >= 3) {
                      const area = digits.substring(0, 3);
                      if (areaCodes && areaCodes.length > 0 && !areaCodes.includes(area)) {
                        setModalError('Invalid area code. Please enter a valid area code.');
                      } else {
                        setModalError('');
                      }
                    } else {
                      setModalError('');
                    }
                  }}
                  autoComplete="tel-local"
                  inputLeftElement={
                    <IconSymbol icon="phone" color="#002677" size="18px" />
                  }
                />

              </Grid.Col>
              <Grid.Col span={4} css={{
                'abyss-grid-col': {
                  display: 'flex',
                  alignItems: 'flex-end'
                }
              }}>
                <Button
                  variant="outline"
                  onClick={handleAddPhoneToTempList}
                  after={<IconSymbol icon="add" />}
                  isDisabled={modalPhoneNumber.replace(/\D/g, '').length !== 10 || modalError !== ''}
                >
                  Add numbers
                </Button>

              </Grid.Col>
               {modalError && (
                  <div style={{ color: 'red', fontSize: '13px',marginLeft:'20px'}}>{modalError}</div>
                )}
            </Grid>
          </div>

          {tempPhoneNumbers.length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <div style={{
                fontWeight: 'bold',
                marginBottom: '10px',
                fontSize: '14px'
              }}>
                Phone Numbers to Add ({tempPhoneNumbers.length})
              </div>
              <Card css={{
                maxHeight: '200px',
                overflowY: 'auto',
                padding: '16px',
                backgroundColor: '#f5f5f5',
                '&::-webkit-scrollbar': {
                  width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#e0e0e0',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#888',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#555',
                }
              }}>
                {tempPhoneNumbers.map((phoneNumber, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '8px',
                      backgroundColor: 'white',
                      borderRadius: '4px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <IconSymbol icon="phone" color="#002677" size="18px" style={{ marginRight: '8px' }} />
                      <span>{phoneNumber}</span>
                    </div>
                    <IconSymbol
                      icon="delete"
                      size="18px"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleRemoveFromTempList(index)}
                    />
                  </div>
                ))}
              </Card>
            </div>
          )}

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <Button
              variant="outline"
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSaveAllPhoneNumbers}
            >
              Save
            </Button>
          </div>
        </Modal.Section>
      </Modal>

       {
              loader && (
                <div
                  style={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9999,
                  }}
                >
                  <LoadingSpinnerComponent isLoading={loader} msg={'Please wait.......'} />
                </div>
              )
            }
    </div>
  );
};
